const Footer2 = () => {
    return (
        <div style={{marginTop: 60}}></div>
    )
}
export default Footer2
